import React from 'react';

import { Icon, Stack, Text } from '@eluve/components';

export const LabeledField: React.FC<{
  label: string;
  error?: string | null;
  children: React.ReactNode;
}> = ({ label, error, children }) => (
  <Stack gap={1}>
    <Text size="xs" weight="medium" color="secondary">
      {label}
    </Text>
    {children}
    {error ? (
      <Stack
        direction="horizontal"
        gap={1}
        align="center"
        className="text-text-negative"
      >
        <Icon name="TriangleAlert" size="xs" />
        <Text size="xs" color="inherit">
          {error}
        </Text>
      </Stack>
    ) : null}
  </Stack>
);
